import { IProductFormValues } from '../../../common/validations/product.validations';

/**
 * Initial values for the product form
 * Consolidated default states from all form components
 */

export const initialValues: IProductFormValues = {
  // Product Details
  productName: '',
  productSku: '',
  linkedTools: [
    {
      id: 1,
      name: 'Coro',
      image: '/images/attack-surface/generic2.svg',
    },
  ],
  category: null,
  subcategory: null,
  suppliers: [{ id: 1, name: 'M3 Networks' }],
  manufacturers: [{ id: 1, name: 'M3 Networks' }],

  // Period Details
  licenseQty: '',
  billingPeriod: 'Monthly',
  snapToUnit: 'Monthly',
  contractTerm: '',
  contractTermUnit: 'Months',
  contractEnd: '',
  monitoredBySoc: 'Monthly',
  periodManufacturers: [],

  // Total Section
  currency: 'GBP',
  cost: '0.00',
  taxRate: 'VAT-10%',
  usdAmount: '0.00',
  gbpAmount: '0.00',
};

